"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var SingleCurrencyCarDetailsContainer_1 = require("./CarDetailsContainer/SingleCurrencyCarDetailsContainer");
var MultiCurrencyCarDetailsContainer_1 = require("./CarDetailsContainer/MultiCurrencyCarDetailsContainer");
var errorHandler_1 = require("../../../common/service/errorHandler");
var CarDetailsContainer = function (props) {
    var _a;
    var isMultiCurrency = props.isMultiCurrency, carDetails = props.carDetails;
    var handleChangeConfiguration = react_1.useCallback(function () {
        if (carDetails.configurationSourceUrl) {
            window.location.href = carDetails.configurationSourceUrl;
            return;
        }
        errorHandler_1.default.warn('There is no configurationSourceUrl set!');
    }, [(_a = carDetails) === null || _a === void 0 ? void 0 : _a.configurationSourceUrl]);
    if (isMultiCurrency) {
        return <MultiCurrencyCarDetailsContainer_1.default {...props} changeConfiguration={handleChangeConfiguration}/>;
    }
    return <SingleCurrencyCarDetailsContainer_1.default {...props} changeConfiguration={handleChangeConfiguration}/>;
};
exports.default = CarDetailsContainer;
